// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__88V9q","toggleWrap":"styles_toggleWrap__3xVre","content":"styles_content__zmloY","selectAreaCode":"styles_selectAreaCode__3J-B5"};